// extracted by mini-css-extract-plugin
module.exports = {"kakaoImg":"Kakao_kakaoImg__1WrJY"};